export default "__VITE_PUBLIC_ASSET__be068026__"